/**
 * Unbiased Fisher–Yates shuffle, shared by every core sampler (diagnostic pick,
 * practice-focus sessions) so a bias fix or a seeded RNG reaches all of them.
 * Returns a new array; never mutates the input.
 *
 * @template T
 * @param {ReadonlyArray<T>} items
 * @param {() => number} [random] 0 ≤ r < 1 source; defaults to Math.random.
 *   Tests inject a deterministic one.
 * @returns {T[]}
 */
export function fisherYates(items, random = Math.random) {
  const arr = Array.isArray(items) ? [...items] : [];
  for (let i = arr.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}
